import { z } from "zod/v4";
import { OcpiDateTime } from "../ocpi.utils";
import { Role } from "./credentials";

const ConnectionStatus = z.enum([
  "CONNECTED",
  "OFFLINE",
  "PLANNED",
  "SUSPENDED",
]);

export const ClientInfo = z.object({
  party_id: z.string().max(3),
  country_code: z.string().length(2),
  role: Role,
  status: ConnectionStatus,
  last_updated: OcpiDateTime,
});

export const ClientInfos = z.array(ClientInfo).nullish();
